import { Component } from 'react'
import { RasaPageComponentProps, RasaPageComponentState } from './types'

export class RasaPageComponent<P extends RasaPageComponentProps, S = any> extends Component<
  P,
  S,
  RasaPageComponentState
> {
  constructor(props) {
    super(props)
  }
}
